import React from "react";
import get from "lodash/get";
import { object } from "prop-types";
import { getSlug } from "../../../utils/utils";
import useViewPort from "../../../../hook/useViewPort";
import { Link, ResponsiveImage } from "@quintype/components";
import "./story-image-for-genret-layout.m.css";
import { CollectionName } from "../../Atoms/CollectionName";
import { useSelector } from "react-redux";
const StoryImageForGenretLayout = ({ collection, config, customCollectionName }) => {
  const typeCollection = get(collection, ["items"]);
  const filterCollection = typeCollection.filter((types) => types.type === "collection");
  const bgColor = get(collection, ["associated-metadata", "Type a number from 1-14 for layout background colors"]) || 1;
  const validNumber = bgColor >= 1 && bgColor <= 14 ? bgColor : 1;
  const colorClass = `color-black-${validNumber}`;
  //const [series1Keys, setSeries1Keys] = useState([]);
  //const [series2Keys, setSeries2Keys] = useState([]);
  const { currentImageIndex, viewports } = useViewPort();
  const defaultImgState = useSelector((state) => get(state, ["qt", "config"]));
  const defaultImage = get(defaultImgState, ["publisher-attributes", "defaultImageKey"], "");

  return (
    <>
      {filterCollection && filterCollection.length > 0 && (
        <div styleName={`container ${colorClass}`}>
          {/**The following collection.slug==="channel-2" is temp. solution when at this point we don't have section with channel-two */}
          {collection.slug !== "channel-2" && (
            <div styleName="collection-name-upper" className={viewports ? viewports : ""}>
              {<CollectionName collection={collection} customCollectionName={customCollectionName} />}
              <i className="ri-arrow-right-line"></i>
            </div>
          )}
          {collection.slug === "channel-2" && (
            <div className={viewports ? viewports : ""}>
              {collection.slug === "channel-2" && (
                <div styleName="collection-name">
                  <Link href="/channel-two">
                    <h2>{collection.name}</h2>
                  </Link>
                  <i className="ri-arrow-right-line"></i>
                </div>
              )}
            </div>
          )}
          <div styleName="image-grid" className={viewports ? viewports : ""}>
            {filterCollection.map((collectionItem, index) => {
                  const behindPaywall = collectionItem?.metadata["behind-paywall"]?.[0]?.name || null;
                  const contentType = collectionItem?.metadata["content-type"]?.[0]?.name || null;
              let slug = (collectionItem && getSlug(collectionItem, defaultImgState)) || "";
              if(collectionItem.slug==="dei"){
                slug="/"
              }
              let collectionHeroImgS3Key =
                (collectionItem.metadata &&
                  collectionItem.metadata["cover-image"] &&
                  collectionItem.metadata["cover-image"]["cover-image-s3-key"]) ||
                defaultImage;
              if (!collectionHeroImgS3Key) return null; //this ensures if section image and defaultImage is not available then just that section will not be shown
              return (
                <div id={collectionItem.id} styleName="image-container" className={viewports ? viewports : ""}>
                  <Link href={slug}>
                    <div styleName="responsive-img">
                      {collectionHeroImgS3Key&&collectionHeroImgS3Key && (
                        <figure>
                        <ResponsiveImage
                          aspectRatio={[16, 9]}
                          defaultWidth={480}
                          widths={[250, 480, 640]}
                          slug={collectionHeroImgS3Key}
                          key={index}
                          alt={collectionHeroImgS3Key}
                        />
                        </figure>
                      )}
                      {/* Subscription icon on top-left */}
                      {behindPaywall ==="Kyllä" &&
                        !collectionItem.slug.startsWith("channel-one") &&
                        !collectionItem.slug.startsWith("channel-2") && (
                          <div styleName="subscription-wrapper">
                            <img
                              alt="subscription-icon"
                              src="/icons/under-subcription.svg"
                              styleName="subscription-image"
                            />
                          </div>
                        )}

                      {/* Audio/Video icon on top-right */}
                      {!collectionItem.slug.startsWith("channel-one") &&
                        !collectionItem.slug.startsWith("channel-2") &&
                        contentType && (
                          <div styleName="audio-video-wrapper">
                            {contentType === "Audio" && (
                              <img alt="audio-logo" src="/icons/podcast-icon-white.svg" styleName="custom-img-icon" />
                            )}
                            {contentType === "Video" && (
                              <img alt="video-logo" src="/icons/video-icon-white.svg" styleName="custom-img-icon" />
                            )}
                          </div>
                        )}
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};
StoryImageForGenretLayout.propTypes = {
  collection: object,
  config: object,
};
export { StoryImageForGenretLayout };
StoryImageForGenretLayout.storyLimit = 22;
